import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getFromServerTopic } from "@utility/slice";

const SLICE = "iaq";
const action = (name) => `${SLICE}/${name}`;

export const getFromServer = (action, contextOptionsFn, payloadFn) =>
  getFromServerTopic({ topic: SLICE, action, contextOptionsFn, payloadFn });

const getDataForDay = getFromServer("getDataForDay", undefined, () => {
  return {
    deviceId: 4,
    day: "2022-11-23",
  };
});

export const initializeIAQPage = createAsyncThunk(
  action("initializeIAQPage"),
  async (arg, { dispatch }) => Promise.all([dispatch(getDataForDay())]),
);

export const recalculateAverageIAQData = getFromServer(
  "recalculateAverageIAQData",
  undefined,
  (payload) => payload,
);

export const getCacheKey = getFromServer("getCacheKey", ({ arg }) => arg);
export const getCacheKeys = getFromServer("getCacheKeys", ({ arg }) => arg);
export const clearCacheKey = getFromServer("clearCacheKey", ({ arg }) => arg);

export const slice = createSlice({
  name: SLICE,
  initialState: {
    aggregations: {},
    cacheResult: undefined,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDataForDay.fulfilled, (state, action) => {
        state.aggregations = action.payload.response;
      })
      .addCase(clearCacheKey.fulfilled, (state, action) => {
        state.cacheResult = action.payload.response;
      })
      .addCase(getCacheKeys.fulfilled, (state, action) => {
        state.cacheResult = action.payload.response;
      })
      .addCase(getCacheKey.fulfilled, (state, action) => {
        state.cacheResult = action.payload.response;
      });
  },
});

export const {} = slice.actions;

export default slice.reducer;
